<script lang="ts">
	import { AdvancedCard, Label, LabelList } from '@Shelly/shelly-design-system';
	import { translateTemplateTitle } from 'src/helpers/xt1_helpers/template_helpers';
	//Types
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	export let status: VCInterfaceStatus;
</script>

<AdvancedCard title={translateTemplateTitle(status.name)} class="mb-s">
	<LabelList
		size="m"
		labelList={status.labelList || []}
		slot="main"
		data-prevent-drawer-swipe
		data-prevent-sidepanel-swipe
	/>
	<div slot="right">
		<Label
			style="max-width: 100%;"
			size="l"
			value={translateTemplateTitle(status.label || status.value)}
			icon={status.icon}
		/>
	</div>
</AdvancedCard>
